import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Navbar from "../../Components/Navbar";
import { useNavigate, useParams } from "react-router-dom";
import "./style.css";
import Cards from "../../Components/Cards";
import { getInsytixEmployees } from "../../api/InsytixEmployees";
import { Card } from "react-bootstrap";
import { useAuthContext } from "../../hooks";
import AdminEmployeeSc from "./index.sc";
import { getOrgUserPtoMasterData } from "../../api/LeaveManagement/getUserMasterPto";
function Index() {
  const [show, setShow] = useState(false);
  const params = useParams();
  const [users, Setusers] = useState<any[]>([]);
  const auth = useAuthContext();
  const fetchAllUsers = async () => {
    const orgId = auth?.userInfo?.orgs?.[0]?.id || 100000000001;
    const rows = await getInsytixEmployees(orgId);
    Setusers(Array.isArray(rows) ? rows : []);
  };

  useEffect(() => {
    fetchAllUsers();
  }, []);
  console.log(` hello ,${users}`);

  const navigate = useNavigate();
  console.log("Users_____", users);
  const [searchInput, setSearchInput] = useState("");

  const handleSearchInputChange = (event: any) => {
    setSearchInput(event.target.value);
  };

  const filteredUsers = (Array.isArray(users) ? users : []).filter((user) => {
    const fullName = user?.Name || "";
    return fullName.toLowerCase().includes(searchInput.toLowerCase());
  });
  return (
    <AdminEmployeeSc>
      <div className="employee-directory-container">
        <div className="main">
          <div className="form-group has-search">
            <input
              type="text"
              className="form-control"
              placeholder="Search Employee"
              value={searchInput}
              onChange={handleSearchInputChange}
            />
          </div>
          <div style={{ padding: "5px", display: "flex", gap: "5px" }}>
            <Button variant="primary" onClick={() => navigate("createUser")}>
              Add Employee
            </Button>
            <Button onClick={() => navigate("peopleLead")}>
              Assign People Lead
            </Button>
          </div>
        </div>
        <div style={{ padding: "0.5rem", fontWeight: "bold" }}>
          Active Employee: {users?.length}
        </div>
        <div className="second-navbar"></div>

        <div className="user-card">
          {filteredUsers &&
            filteredUsers?.map((data) => {
              return (
                <>
                  <Cards
                    key={data.id}
                    name={data?.Name}
                    onClick={() => {
                      if (data?.org_user_id) navigate(`${data.org_user_id}`);
                    }}
                  />
                </>
              );
            })}
        </div>
      </div>
    </AdminEmployeeSc>
  );
}

export default Index;
